import template from './breadcrumb.template.html';
import './breadcrumb.scss';

export default {
  template,
  bindings: {
    items: '<',
    onBreadcrumbClick: '&',
  },
};



// WEBPACK FOOTER //
// ./src/app/shared/breadcrumb/breadcrumb.component.js